import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const ReportExportEventSchema = z.object({
    type: z.literal('report.export'),
    ...baseEventFields,
    reportId: uuidSchema,
    reportType: z.string().min(1),
    format: z.enum(['csv', 'xlsx', 'pdf', 'json']),
    requestedBy: uuidSchema,
    destinationUrl: z.string().url().optional(),
});
//# sourceMappingURL=report.js.map